/**
 * Service Registry
 * Exports singleton instances of all services for use across the application
 */

import { RefinementService } from './refinement.service';
import { TranscriptionService } from './transcription.service';

export { ApiError, type ApiRequestOptions, ApiService } from './api.service';
export { RefinementService } from './refinement.service';
export { TranscriptionService } from './transcription.service';

/**
 * Singleton instance of TranscriptionService
 * Use this for all token-related operations
 *
 * @example
 * ```typescript
 * import { transcriptionService } from '@/services';
 *
 * const { token } = await transcriptionService.getToken();
 * ```
 */
export const transcriptionService = new TranscriptionService();

/**
 * Singleton instance of RefinementService
 * Use this for all text refinement operations
 *
 * @example
 * ```typescript
 * import { refinementService } from '@/services';
 *
 * const result = await refinementService.refine(text, prompt);
 * console.log(result.refinedText);
 * ```
 */
export const refinementService = new RefinementService();
